<template>
  <div class="bamboo-input input">
    <label v-if="!!label">{{ label }} <span v-if="required && !!label">*</span></label>
    <div class="items">
      <div
        v-for="item in itemsList"
        class="item"
        :class="{ active: item.active }"
        :key="item.value"
        @click="select(item.value)"
      >
        {{ item.text }}
      </div>
    </div>
    <small class="red" v-if="!!validateMessage">{{ validateMessage }}</small>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api';

export default {
  name: 'BambooInput',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Number, String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Function,
      default: () => ''
    }
  },
  setup(props, { emit, root }) {
    const validateMessage = ref('');
    const isValid = ref(false);

    const wrappedValue = computed({
      get() { return props.value; },
      set(val) {
        emit('input', val);
      }
    });

    const parseValueToArray = () => {
      let val;
      if (wrappedValue.value) {
        if (typeof wrappedValue.value === 'string') {
          val = [wrappedValue.value];
        } else {
          if (
            (typeof wrappedValue.value === 'object')
            && Object.prototype.hasOwnProperty.call(wrappedValue.value, 'length')
          ) {
            val = wrappedValue.value;
          } else {
            val = [wrappedValue.value];
          }
        }
      } else {
        val = [];
      }

      return val;
    };

    const itemsList = computed(() => {
      const list = props.items.map((item) => ({
        ...item,
        active: false
      }));

      const actives = parseValueToArray();

      actives.forEach((val) => {
        const i = list.findIndex((item) => (item.value === val));
        if (i >= 0) {
          list[i].active = true;
        }
      });

      return list;
    });

    const select = (val) => {
      if (props.multiple) {
        if (
          (typeof wrappedValue.value === 'object')
          && Object.prototype.hasOwnProperty.call(wrappedValue.value, 'length')
        ) {
          const i = wrappedValue.value.findIndex((v) => (v === val));

          if (i < 0) {
            wrappedValue.value.push(val);
          } else {
            wrappedValue.value = [
              ...wrappedValue.value.slice(0, i),
              ...wrappedValue.value.slice(i + 1, wrappedValue.value.length),
            ];
          }
        } else {
          wrappedValue.value = [val];
        }
      } else {
        wrappedValue.value = val;
      }
    };

    const alert = (msg) => {
      validateMessage.value = msg;
    };

    const validateInput = () => {
      const vals = parseValueToArray();

      if (props.required && !vals.length) {
        alert(root.$t('REQUIRED_FIELD'));
        return false;
      }

      const msg = props.validate(wrappedValue.value);

      if (msg) {
        alert(root.$t(msg));
        return false;
      }

      alert('');
      return true;
    };

    watch(wrappedValue, () => {
      isValid.value = validateInput();
      if (wrappedValue.value === '') {
        alert('');
      }
    });

    return {
      itemsList,
      select,
      validateMessage,
      validateInput,
      isValid
    };
  }
};
</script>

<style lang="scss">
@import '~@/assets/scss/colors';

.bamboo-input {
  transform: translateY(-7px);

  label {
    font-weight: bold;
    padding-left: 2px;
    font-size: 14px;
    margin-bottom: 7px;
    pointer-events:none;

    span {
      color: $geranium;
    }
  }

  .items {
    .item {
      height: 40px;
      border: 1px solid $independence;
      margin-left: -1px;
      background-color: $babyPowder;
      color: $independence;
      transition: all .2s ease-in-out;
      display: inline-block;
      padding: 7px 15px;
      text-align: center;
      cursor: pointer;

      &:first-child {
        margin-left: 0;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
      }

      &:last-child {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }

      &:hover, &.active {
        margin-left: 0;
        background-color: $geranium;
        color: $babyPowder;
        border-color: $geranium;
      }
    }
  }

  small {
    &.red {
      color: $geranium;
    }
  }
}
</style>
